var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightening(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1011.81 1212.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;fill-rule:evenodd;stroke:#363435;stroke-linecap:round;stroke-linejoin:round;stroke-width:8.4px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M346.01,1030.76c38.13-29.73,451.11-242.97,464.6-257.68,13.56-14.77-401.85-54.95-368.82-70.09,33.17-15.23,528.49-236.82,522.17-256.7-6.35-19.99-369.75-55.45-351.99-67.87,17.83-12.46,395.65-374.21,395.65-374.21,0,0-862.44,344.17-841.24,368.29,21.07,23.98,386.75,71.21,364.84,87.42C509.4,476.05,17.46,722.01,4.5,681.45c-13.11-41.03,409.63,113.41,409.63,113.41L26.71,1208.58l528.79-412.13-267.98-94.15,441.69-249.07-335.98-80.47L819.41,116.01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightening);
export default __webpack_public_path__ + "static/media/lightening.3621cb363cce26338a28e723fae503bd.svg";
export { ForwardRef as ReactComponent };